import api from "./AxiosInterceptor";
import EndpointService from "./EndpointService";
import { convertObjectValuesToStrings } from "./CommonServices";

export const putNameService = async (payload) => {
  const url = EndpointService("name");
  const response = await api.put(url, payload);
  return response;
};

export const putResetMyProfilePasswordService = async (data) => {
  const url = EndpointService("resetMyProfilePassword");
  const response = await api.put(url, convertObjectValuesToStrings(data));
  return response;
};

export const getMyProfileService = async () => {
  const url = EndpointService("myProfile");
  const response = await api.get(url);
  return response;
};

export const postNewPasswordMyProfileService = async (data, apiAction) => {
  const url = EndpointService("newPasswordProfile").replace(
    "{action}",
    apiAction
  );
  const response = await api.post(url, data);
  return response;
};

export const getDashboardDetailsService = async () => {
  const url = EndpointService("dashboardDetails");
  const response = await api.get(url);
  return response;
};

export const getAssociatedLocationsService = async (payload) => {
  const url = EndpointService("associatedLocations");
  const response = await api.post(url, payload);
  return response;
};

export const putAccountNameSettingsService = async (payload) => {
  const url = EndpointService("accountNameSettings");
  const response = await api.put(url, payload);
  return response;
};

export const postMessageCenterService = async (data) => {
  const url = EndpointService("postMessageCenter");
  const response = await api.post(url, data);
  return response;
};

export const postProviderMessageCenterService = async (payload) => {
  const url = EndpointService("postProviderMessageCenter");
  const response = await api.post(url, payload);
  return response;
};
